<template>
  <div id="app" class="app-main">
     <!-- :key="key" -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
 //  computed:{
	//     key(){
	//         return this.$route.path + Math.random();
	//     }
	// }
}
</script>

<style lang="less">
  @import "./styles/main.less";
  .el-dialog__wrapper {
    text-align: center;
    white-space: nowrap;
    overflow: auto;
 /*   margin-left: 10.4%;
    margin-top: 3.3%;*/
    &:after {
      content: '';
      display: inline-block;
      vertical-align: middle;
      height: 100%;
    }
    .el-dialog {
      margin: 0px auto !important;
      display: inline-block;
      vertical-align: middle;
      text-align: left;
      white-space: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?ce08220e